import PropTypes from 'prop-types';
import React from 'react';
import noop from 'lodash/noop';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { KEY_CODES } from '@sm360/widget-commons-forms';

import 'build-and-quote/components/OptionsResolutions/components/ResolutionFooter/ResolutionFooter.scss';

class ResolutionFooter extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
    }

    componentDidMount() {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            const keyUpListener = windowProxy.addEventListener('keyup', ({ keyCode }) =>
                this.onKeyUp(keyCode).then(() => windowProxy.removeEventListener('keyup', keyUpListener))
            );
        }
    }

    onKeyUp(keyCode) {
        const windowProxy = WindowProxy.get();
        if (windowProxy) {
            if (keyCode === KEY_CODES.ESCAPE) {
                return this.handleCancel();
            }
        }
        return Promise.resolve();
    }

    handleClick() {
        this.props.actions.applyOptionSelectionResolution();
        this.props.onClose();
        return Promise.resolve();
    }

    handleCancel() {
        this.props.purchaseMethodsActions.selectOptionsResolution('');
        return this.handleClick();
    }

    render() {
        return (
            <div className="optionsResolutions__footer">
                <button onClick={this.handleCancel} className="sr-link">
                    {LocaleService.t('OPTIONS_RESOLUTIONS.CANCEL')}
                </button>
                <button onClick={this.handleClick} className="sr-button-1 is-small">
                    {LocaleService.t('OPTIONS_RESOLUTIONS.CONTINUE')}
                </button>
            </div>
        );
    }
}

ResolutionFooter.defaultProps = {
    onClose: noop,
};

ResolutionFooter.propTypes = {
    actions: PropTypes.shape({
        applyOptionSelectionResolution: PropTypes.func.isRequired,
    }).isRequired,
    onClose: PropTypes.func,
    purchaseMethodsActions: PropTypes.shape({
        selectOptionsResolution: PropTypes.func.isRequired,
    }).isRequired,
};

ResolutionFooter.displayName = 'ResolutionFooter';

export default ResolutionFooter;
